"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminPaymentContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.adminPaymentContract = c.router({
    getDetailedPlayerAccountJournal: {
        method: 'GET',
        path: '/:player_id/account-journal',
        pathParams: zod_1.z.object({
            player_id: zod_1.z.string(),
        }),
        query: zod_1.z.object({
            page: zod_1.z.coerce.number(),
            pageSize: zod_1.z.coerce.number(),
        }),
        responses: {
            200: models_1.ZDetailedAccountJournal,
            404: c.type(),
        },
        summary: 'Admin get player account journal',
    },
}, {
    pathPrefix: '/admin',
    strictStatusCodes: true,
    jsonQuery: true,
    commonResponses: {
        401: c.type(),
        403: c.type(),
    },
    baseHeaders: zod_1.z.object({
        'x-access-token': zod_1.z.string(),
    }),
});
//# sourceMappingURL=payment.admin.contract.js.map